import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "currency-converter-settings__title-block" }
const _hoisted_2 = { class: "currency-converter-settings__logo" }
const _hoisted_3 = { class: "currency-converter-settings__name-block" }
const _hoisted_4 = {
  key: 0,
  class: "currency-converter-settings__name-block"
}
const _hoisted_5 = {
  key: 1,
  class: "currency-converter-settings__name-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FallbackImage = _resolveComponent("FallbackImage")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isCurrencyConverterSettingsSidebarVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCurrencyConverterSettingsSidebarVisible) = $event)),
    title: "Converter settings",
    "append-to-body": "",
    size: "700",
    class: "currency-converter-settings",
    onClose: _ctx.closeCurrencyConverterSettings
  }, {
    footer: _withCtx(() => [
      (_ctx.isCurrencyConverterFormChanged)
        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "Are you sure you want to close converter settings?",
            width: "250",
            "cancel-button-text": "Cancel",
            "confirm-button-text": "Yes, close",
            icon: _ctx.icons.InfoFilled,
            "confirm-button-type": "primary",
            onConfirm: _ctx.closeCurrencyConverterSettings
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { loading: _ctx.isPaymentMethodCurrencyConverterListLoading }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Cancel ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon", "onConfirm"]))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            loading: _ctx.isPaymentMethodCurrencyConverterListLoading,
            onClick: _ctx.closeCurrencyConverterSettings
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Cancel ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading", "onClick"])),
      _createVNode(_component_el_popconfirm, {
        title: "Are you sure?",
        width: "224",
        "cancel-button-text": "No, cancel",
        "confirm-button-text": "Yes, save",
        icon: _ctx.icons.InfoFilled,
        "confirm-button-type": "primary",
        onConfirm: _ctx.saveCurrencyConverterSettings
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            loading: _ctx.isPaymentMethodCurrencyConverterListLoading,
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Save ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["loading"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["icon", "onConfirm"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FallbackImage, {
              "model-value": _ctx.currentPaymentMethod,
              class: "currency-converter-settings__image"
            }, null, 8 /* PROPS */, ["model-value"])
          ]),
          _createElementVNode("p", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Internal name", -1 /* CACHED */)),
            _createVNode(_component_el_tag, { type: "info" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentPaymentMethod.paymentSystem), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          (_ctx.currentPaymentMethod.publicName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Public name", -1 /* CACHED */)),
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentPaymentMethod.publicName), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.currentPaymentMethod.billingProviderName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Billing provider", -1 /* CACHED */)),
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentPaymentMethod.billingProviderName), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethodCurrencyConverterList, (currencyConverter, cardIndex) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            key: currencyConverter.currencyTo,
            shadow: "hover",
            class: "currency-converter-settings__card-item"
          }, {
            header: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(cardIndex + 1) + ". Converter", 1 /* TEXT */),
              _createVNode(_component_el_button, {
                class: "currency-converter-settings__delete-button",
                loading: _ctx.isPaymentMethodCurrencyConverterListLoading,
                icon: _ctx.icons.Close,
                circle: "",
                flat: "",
                onClick: ($event: any) => (_ctx.removeCurrencyConverter(cardIndex))
              }, null, 8 /* PROPS */, ["loading", "icon", "onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                ref_for: true,
                ref: "currencyConverterFormRefs",
                model: currencyConverter,
                rules: _ctx.currencyConverterSettingsFormRules,
                "label-width": "auto",
                "require-asterisk-position": "right",
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "From",
                    prop: "currencyFromList"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: currencyConverter.currencyFromList,
                        "onUpdate:modelValue": ($event: any) => ((currencyConverter.currencyFromList) = $event),
                        placeholder: "Select currency from",
                        filterable: "",
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCurrency(cardIndex, 'currencyFromList'), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8 /* PROPS */, ["label", "value"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_el_form_item, {
                    label: "To",
                    prop: "currencyTo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: currencyConverter.currencyTo,
                        "onUpdate:modelValue": ($event: any) => ((currencyConverter.currencyTo) = $event),
                        placeholder: "Select currency to",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCurrency(cardIndex, 'currencyTo'), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8 /* PROPS */, ["label", "value"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model", "rules"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.isAddCurrencyConverterButtonVisible)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "currency-converter-settings__add-exception",
              type: "primary",
              plain: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCurrencyConverter()))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Add converter ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])), [
        [_directive_loading, _ctx.isPaymentMethodCurrencyConverterListLoading]
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}